import { Component, Input, OnInit } from '@angular/core';
import { OperationalAssurancesSection } from 'src/app/model/shared/operational-assurance-section.';

@Component({
  selector: 'app-operational-assurances-section',
  templateUrl: './operational-assurances-section.component.html',
  styleUrls: ['./operational-assurances-section.component.scss']
})
export class OperationalAssurancesSectionComponent implements OnInit {
  @Input() sections: OperationalAssurancesSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
